/* **************************************************** Kitchen finish */
export interface FSKitchenFinish {
    id: number;
    finish_name: string;
}

export const mapFSKitchenFinish = (data: any): FSKitchenFinish => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSKitchenFinish = {
        id: data.id,
        finish_name: data.finish_name
    };

    return res;
};

export const mapFSKitchenFinishes = (data: any[]): FSKitchenFinish[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSKitchenFinish);
};